import Ajax from '../utils/Ajax';
import AppDispatcher from '../dispatcher/AppDispatcher';
import BankTransferConstants from '../constants/BankTransferConstants';

export default {
    // payload: { id (payment id), booking_id, files }
    createBankTransferRequest: function (payload) {
        AppDispatcher.handleAction({
            actionType: BankTransferConstants.BANK_TRANSFER_LOADING,
            data: {
                booking_id: payload.booking_id,
            },
        });

        Ajax.createBankTransferRequest(payload, (progress) => {
            AppDispatcher.handleAction({
                actionType: BankTransferConstants.BANK_TRANSFER_PROGRESS,
                data: {
                    booking_id: payload.booking_id,
                    progress,
                },
            });
        })
            .done((request) => {
                console.log('Got bank transfer request:', request);
                const { reference_number } = request || {};
                if (!reference_number) {
                    console.error('Reference number not found on response');
                    AppDispatcher.handleAction({
                        actionType: BankTransferConstants.BANK_TRANSFER_FAILED,
                        data: {
                            booking_id: payload.booking_id,
                        },
                    });
                    return;
                }

                AppDispatcher.handleAction({
                    actionType: BankTransferConstants.BANK_TRANSFER_SUCCESS,
                    data: {
                        booking_id: payload.booking_id,
                        request,
                    },
                });
            })
            .fail((err) => {
                console.error('Error while creating bank transfer request:', err);
                AppDispatcher.handleAction({
                    actionType: BankTransferConstants.BANK_TRANSFER_FAILED,
                    data: {
                        booking_id: payload.booking_id,
                    },
                });
            });
    },
};
